import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useAuth } from '../../contexts/AuthContext';
import { 
  Menu, 
  Crown
} from 'lucide-react';

const ChatHeader = ({ onToggleSidebar, isSidebarOpen }) => {
  const { conversationId } = useParams();
  const { user } = useAuth();

  const getPlanBadgeColor = (plan) => {
    switch (plan) {
      case 'free': return 'bg-gray-100 text-gray-700';
      case 'standard': return 'bg-yellow-100 text-yellow-700';
      case 'premium': return 'bg-red-100 text-red-700';
      case 'lifetime': return 'bg-purple-100 text-purple-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };

  const getPlanIcon = (plan) => {
    if (plan === 'premium' || plan === 'lifetime') {
      return <Crown className="w-3 h-3" />;
    }
    return null;
  };

  return (
    <div className="bg-white border-b border-gray-200 px-4 py-3">
      <div className="flex items-center justify-between">
        {/* Left Side */}
        <div className="flex items-center space-x-3">
          {/* Sidebar Toggle - Hidden on desktop when sidebar is open */}
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleSidebar}
            className={`${isSidebarOpen ? 'hidden md:flex' : 'flex'}`}
          >
            <Menu className="w-4 h-4" />
          </Button>

          {/* Conversation Title */}
          <div className="flex items-center space-x-2">
            <h1 className="text-lg font-semibold text-gray-900">
              {conversationId ? 'Lawful Assistant' : 'Welcome to TheEqualizer.AI'}
            </h1>
            
            {/* Plan Badge */}
            <Badge 
              variant="outline" 
              className={`text-xs ${getPlanBadgeColor(user?.subscription_plan)}`}
            >
              {getPlanIcon(user?.subscription_plan)}
              <span className={getPlanIcon(user?.subscription_plan) ? 'ml-1' : ''}>
                {user?.subscription_plan?.charAt(0).toUpperCase() + user?.subscription_plan?.slice(1)}
              </span>
            </Badge>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center space-x-2">
          {/* Removed non-functional buttons: Share, Download, and MoreVertical */}
        </div>
      </div>

      {/* Subtitle */}
      {!conversationId && (
        <div className="mt-2">
          <p className="text-sm text-gray-600">
            Start a new conversation to get AI-powered legal assistance tailored to your subscription plan
          </p>
        </div>
      )}
    </div>
  );
};

export default ChatHeader;